<template>
	<div class="experience-travel-addon">
		<div v-for="(item, key) in basketItemsData" :key="key">
			<div class="experience-block__white-header" :class="{ 'experience-block__white-header--first': key === 0 }">
				#{{ item.reference }} - {{ item.packageName }}
			</div>

			<div class="experience-travel-addon__selected" full-width>
				<h3>{{ $t('experiencecontenttraveladdon.selected') }}</h3>

				<span v-for="(addon, key) in item.items" :key="key">
					<p class="experience-travel-addon__detail">{{ addon.quantity }}x {{ addon.title }}</p>
				</span>
			</div>
		</div>

		<div>
			<div class="experience-travel-addon__button-container" v-if="!isShopUpdatePending">
				<Button class="experience-travel-addon__button button--small" :to="`traveladdon`">
					{{ buttonLabel }}
				</Button>
			</div>

			<div v-else>
				<Spinner />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ExperienceContentTravelAddon',

	props: {
		products: Array,
		route: String,
		buttonLabel: String
	},

	computed: {
		packageData() {
			return this.products;
		},

		travelPackages() {
			return this.$store.getters['travelapi/getPackages'];
		},

		travelDetailRoute() {
			const detail = this.$store.getters['travelapi/getPackages'].find(
				pack => pack.id === this.packageData.package.id
			).slug;

			return `${this.route}/${detail}`;
		},

		isShopUpdatePending() {
			return this.$store.getters['shopapi/getIsShopUpdatePending'];
		},

		purchasedProductData() {
			return this.$store.getters['shopapi/getPurchasedProducts'].data.data;
		},

		packagesData() {
			return this.purchasedProductData && this.purchasedProductData.upsell.hospitality['add_on'];
		},

		remappedAddonsInBasket() {
			const tempData = {};
			// Remapping addons to group for reference
			this.packageData.forEach(addon => {
				let idStr = Object.keys(addon)[0];
				if (!tempData[idStr]) {
					tempData[idStr] = [];
				}
				tempData[idStr].push({
					...addon[idStr]
				});
			});
			return tempData;
		},

		basketItemsData() {
			return Object.keys(this.remappedAddonsInBasket).map(reference => {
				const items = this.remappedAddonsInBasket[reference].map(addon => {
					const price = addon.type.options.find(option => option.amount == addon.quantity).price;
					return {
						id: addon.type.id,
						title: addon.type.name || '',
						description: addon.type.content.description,
						quantity: addon.quantity,
						price: Number(price.replace('.', '').replace(',', '.')),
						image: addon.type.image,
						hideButtons: true,
						showRemoveButton: true
					};
				});
				const travelPackage = this.packagesData.find(travelPackage => travelPackage.reference == reference);

				return {
					reference,
					items,
					packageName: travelPackage.cart.package.name,
					travelPackage
				};
			});
		}
	}
};
</script>

<style lang="scss">
$component: 'experience-travel-addon';

.#{$component} {
	&__grid {
		padding: $global-spacing;
	}

	&__title {
		margin-bottom: $global-spacing;
	}

	&__button-container {
		display: flex;
		justify-content: space-around;

		padding: calc($global-spacing / 2) $global-spacing $global-spacing;
	}

	h3 {
		opacity: 0.8;

		margin-bottom: calc($global-spacing / 2);

		font-size: 16px;
		text-transform: uppercase;
	}

	p {
		font-size: 14px;
	}

	&__detail {
		margin-bottom: $global-spacing * 0.75;

		svg {
			margin-right: 4px;
		}
	}

	&__button {
		max-width: 200px;
	}

	&__selected {
		padding: 0 $global-spacing;
		margin-bottom: $global-spacing;

		font-size: 14px;
	}
}
</style>
